class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    const facetForms = document.querySelectorAll("facet-filters-form");
    facetForms.forEach((form) => form.classList.add("loading"));
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML;
    const containers = document.querySelectorAll("[data-product-count]");
    containers.forEach((container) => {
      container.innerHTML = count;
    });

    const facetForms = document.querySelectorAll("facet-filters-form");
    facetForms.forEach((form) => form.classList.remove("loading"));
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.remove("loading");
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
  }

  static renderActiveFacets(html) {
    const selector = "[data-active-facets]";

    const activeFacetsElement = html.querySelector(selector);
    if (!activeFacetsElement) return;
    document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-facets__open", ".mobile-facets__count", ".sorting"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML = source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll("facet-filters-form form");
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(event.target.closest("form"));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event, resetPrices = false) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
    resetPrices && document.querySelector("price-slider").reset();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.rangeInputs = this.querySelectorAll(".price-range input");
    this.priceInputs = this.querySelectorAll(".price-input input");
    this.progress = this.querySelector("[data-progress]");
    this.priceGap = this.dataset.priceGap ? parseInt(this.dataset.priceGap) : 0;
    this.calibrateProgress();

    this.priceInputs.forEach((input) => {
      input.addEventListener("change", this.onPriceInput.bind(this));
    });

    this.rangeInputs.forEach((input) => {
      input.addEventListener("input", this.onRangeInput.bind(this));
    });
  }

  onPriceInput(e) {
    let minPrice = parseInt(this.priceInputs[0].value);
    let maxPrice = parseInt(this.priceInputs[1].value);

    if (maxPrice - minPrice < this.priceGap) {
      if (e.target.dataset.limit === "min") {
        this.priceInputs[0].value = maxPrice - this.priceGap;
        minPrice = parseInt(this.priceInputs[0].value);
      } else {
        this.priceInputs[1].value = minPrice + this.priceGap;
        maxPrice = parseInt(this.priceInputs[1].value);
      }
    }

    this.rangeInputs[0].value = minPrice;
    this.rangeInputs[1].value = maxPrice;
    this.progress.style.left = (minPrice / this.rangeInputs[0].max) * 100 + "%";
    this.progress.style.right = 100 - (maxPrice / this.rangeInputs[1].max) * 100 + "%";

    this.calibratePriceInputLimits();
  }

  calibratePriceInputLimits() {
    this.priceInputs[0].max = parseInt(this.priceInputs[1].value || this.dataset.maxPrice) - this.priceGap;
    this.priceInputs[1].min = parseInt(this.priceInputs[0].value) + this.priceGap;
  }

  calibrateProgress() {
    let minVal = parseInt(this.rangeInputs[0].value);
    let maxVal = parseInt(this.rangeInputs[1].value);

    this.progress.style.left = (minVal / this.rangeInputs[0].max) * 100 + "%";
    this.progress.style.right = 100 - (maxVal / this.rangeInputs[1].max) * 100 + "%";
  }

  onRangeInput(e) {
    let minVal = parseInt(this.rangeInputs[0].value);
    let maxVal = parseInt(this.rangeInputs[1].value);

    if (maxVal - minVal < this.priceGap) {
      if (e.target.dataset.limit === "min") {
        this.rangeInputs[0].value = maxVal - this.priceGap;
      } else {
        this.rangeInputs[1].value = minVal + this.priceGap;
      }
    } else {
      this.priceInputs[0].value = minVal;
      this.priceInputs[1].value = maxVal;
      this.progress.style.left = (minVal / this.rangeInputs[0].max) * 100 + "%";
      this.progress.style.right = 100 - (maxVal / this.rangeInputs[1].max) * 100 + "%";
    }

    this.calibratePriceInputLimits();
  }

  reset() {
    this.priceInputs[0].value = 0;
    this.priceInputs[1].value = parseInt(this.dataset.maxPrice);
    this.rangeInputs[0].value = 0;
    this.rangeInputs[1].value = parseInt(this.dataset.maxPrice);
    this.progress.style.right = 0;
    this.progress.style.left = 0;
  }
}

customElements.define("price-slider", PriceSlider);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event, this.dataset.resetPrice);
  }
}

customElements.define("facet-remove", FacetRemove);
